import { render } from "./DownloadCv.vue?vue&type=template&id=5ca620de&ts=true"
import script from "./DownloadCv.vue?vue&type=script&lang=ts"
export * from "./DownloadCv.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__